import React from 'react'
import './index.scss'
import { connect } from 'react-redux'
import Dialog from '../../common/dialog'
import Units from './units'
import Coordinates from './coordinates'
import Terms from './terms'
import PrivacyPolicy from './privacy-policy'
import Contact from './contact'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'

class Settings extends Dialog {
  constructor(props) {
    super(props)
    this.state = {
      selectedTab: 'units'
    }
  }

  componentDidMount() {

  }

  render() {
    const { selectedTab } = this.state,
      { collapseLeftToolbar } = this.props
    //units, coords, terms, pPolicy, contact
    return (
      <div className='left-expanded-content-container' style={{ overflow: 'hidden' }}>
        <div style={{ width: 360, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div className='left-expanded-header-container'>
            <span className='left-expanded-header'>Settings</span>
            <div className='default-close left-dialog-close' onClick={collapseLeftToolbar}></div>
          </div>
          <div className='left-expanded-tabs-settings-container'>
            {[
              this.makeTab({
                tab: 'units',
                label: 'Units/ Measure',
                active: '../../../../../asset/Pencil-Ruler_Solid_FFFFFF_ldpi.png',
                inactive: '../../../../../asset/Pencil-Ruler_Solid_4F4F4F_ldpi.png',
                // inactive: '../../../../../asset/Pencil-Ruler_Solid_FFFFFF_ldpi.png'

              }, '20%'),
              this.makeTab({
                tab: 'coords',
                label: 'Coordinates',
                active: '../../../../../asset/Globe-Flat_Solid_FFFFFF_ldpi.png',
                inactive: '../../../../../asset/Globe-Flat_Solid_4F4F4F_ldpi.png',

              }, '20%'),
              this.makeTab({
                tab: 'terms',
                label: 'Terms of Use',
                active: '../../../../../asset/Briefcase_Solid_FFFFFF_ldpi.png',
                inactive: '../../../../../asset/Briefcase_Solid_4F4F4F_ldpi.png',

              }, '20%'),
              this.makeTab({
                tab: 'pPolicy',
                label: 'Privacy Policy',
                active: '../../../../../asset/Shield-Check_Solid_FFFFFF_ldpi.png',
                inactive: '../../../../../asset/Shield-Check_Solid_F4F4F4_ldpi.png',

              }, '20%'),
              this.makeTab({
                tab: 'contact',
                label: 'Contact Us',
                active: '../../../../../asset/Envelope_Solid_FFFFFF_hdpi.png',
                inactive: '../../../../../asset/Envelope_Solid_4F4F4F_hdpi.png',
              }, '20%')
            ]}
          </div>
          {
            selectedTab === 'units' ? <Units /> :
              selectedTab === 'coords' ? <Coordinates /> :
                selectedTab === 'terms' ? <Terms /> :
                  selectedTab === 'pPolicy' ? <PrivacyPolicy /> :
                    selectedTab === 'contact' ? <Contact /> :
                      null
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  token: state.auth.token
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Settings)